import _ from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import TicketItems from '../components/TicketItems';
import TicketBarcodeItems from '../components/TicketBarcodeItems'
import TicketModal from '../components/TicketModal';
import NotFoundPage from './NotFoundPage';

import BackImg from '../assets/images/backArrow.png';

@inject(
  'ticketStore',
  'packageStore'
)
@observer
export default class TicketPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ticketInfo: null,
      isBarcodeList: false,
      shopCode: null,
      isUpdated: false,
      isLoaded: false
    }
  }

  componentWillMount() {
    this.setTicketListInStore();
  }
  
  openModal = () => {
    const {
      ticketStore: {
        controlModal,
        getAvailableTickets
      },
    } = this.props;

    const ticketList = getAvailableTickets();
    if(_.isArray(ticketList.availableTickets) && ticketList.availableTickets.length > 0) {
      controlModal(true);
    }
  }

  setTicketListInStore = () => {
    const {
      ticketStore: {
        getShopSequence,
        getTicketInfo,
        setTicketGroups:setTicketGroupsInStore,
      },
      location,
    } = this.props;
    const pathname = location.pathname;
    const barcode = pathname.split('/')[2].replace(/[()<>\{\}\[\]]/gi, '');

    if (location.search.length > 0) {
      const shopCode = location.search.replace('?shopSeq=', '');
      this.setState({ 
        barcode,
        shopCode,
        isLoaded: true
      }, () => {
        const isLoaded = setTicketGroupsInStore(barcode, shopCode);
        if(isLoaded) {
          getTicketInfo(barcode, shopCode);
          setTimeout(() => {
            const {
              ticketInfo: {
                displayType
              }
            } = this.props.ticketStore;
            if(displayType !== 'BARCODE') {
              this.openModal();
            }
          }, 200);
        }
      });
    } else {
      getShopSequence(barcode)
        .then(shopSequence => { 
          this.setState({ 
            barcode,
            shopCode: shopSequence,
            isLoaded: true
          }, () => {
            const isLoaded = setTicketGroupsInStore(barcode, this.state.shopCode);
            if(isLoaded) {
              getTicketInfo(barcode, this.state.shopCode);
              setTimeout(() => {
                const {
                  ticketInfo: {
                    displayType
                  }
                } = this.props.ticketStore;
                if(displayType !== 'BARCODE') {
                  this.openModal();
                }
              }, 200);
            }
          });
        });
    }
  };

  renderGroups(ticketGroups, ticketGroupsCount, tickets, isBarcodeList) {
    if (_.isEmpty(ticketGroups)) return;

    const names = [];
    _.forEach(ticketGroups, (ticketGroup) => {
      names.push(ticketGroup.groupName)
    });

    const groups = [];
    let startCount = 0;
    let endCount = 0;

    _.forEach(ticketGroupsCount, (ticketCount, index) => {
      if (index === 0) { 
        endCount = ticketCount;
      } else {
        endCount = endCount + ticketCount;
      }
      groups.push(_.slice(tickets, startCount, endCount));
      startCount = startCount + ticketCount;
    });

    return _.map(groups, (group, index) => {
      if (!isBarcodeList) {
        return (
          <TicketItems 
            groupNm={names[index]} 
            key={index}
            items={group}
          />
        );
      } else {
        return (
          <TicketBarcodeItems 
            groupNm={names[index]} 
            key={index}
            items={group}
          />
        );
      }
    });
  }

  renderGroupsInfo = (isBarcodeList, shopData) => {
    if (isBarcodeList) return false;
    if (_.isEmpty(shopData.info)) return false;

    return (
      <div className="group-info">
        <h3 className="info-title">상품안내</h3>
        <div className="info-content" dangerouslySetInnerHTML={ {__html: shopData.info} } />
      </div>
    )
  }

  openBarcodeList = () => {
    this.setState({ 
      isBarcodeList : true,
      isUpdated: true,
    });
  }

  openMobileList = () => {
    this.setState({ 
      isBarcodeList : false,
      isUpdated: true,
    }, () => {
      this.openModal();
    });
  }

  AllTrueChange = () => {
    const {
      ticketStore: {
        AllTrueChange,
        allChecked,
      },
    } = this.props;

    const getAllCheckedList = AllTrueChange(allChecked);
    this.renderGroups(getAllCheckedList);
  }

  renderButtonText = () => {
    const {
      ticketStore: {
        checkedTickets,
      },
    } = this.props;

    if (checkedTickets.length > 0) {
      return (
        `총 <span class="num-navigator">${checkedTickets.length}</span>개 사용처리`
      )
    }

    return `선택해주세요`;
  }

  renderTicketPageHeader = (shopData, isBarcodeList, backLink) => {
    return (
      <header className="App-header">
        <Link to={backLink} className="App-back"><img src={BackImg} width="20" alt="뒤로 가기" /></Link>
        <h1 className="App-title">
          {shopData.shopNm}
        </h1>
        <ul className="App-tab">
          {
            isBarcodeList ?
            (
              <li className={'active'}>
                <button 
                  type="button" 
                  className="btn-tab barcode"
                  onClick={this.openBarcodeList}
                > 
                  바코드로 입장
                </button>
              </li>
            )
            :
            (
              <li className={'active'}>
                <button 
                  type="button" 
                  className="btn-tab mobile"
                  onClick={this.openMobileList}
                >
                  모바일로 입장
                </button>
              </li>
            )
          }
        </ul>
      </header>
    )
  };

  render() {
    const {
      ticketStore: {
        barcode,
        ticketGroups,
        ticketGroupsCount,
        tickets,
        ticketInfo,
        allChecked,
      },
    } = this.props;

    if (_.isEmpty(ticketInfo) || _.isEmpty(tickets)) return (
      <NotFoundPage />
    );

    const backLink = '/package/' + barcode;
    const shopData = _.isArray(ticketInfo) ? ticketInfo[0] : ticketInfo;
    let isBarcodeList = (ticketInfo.displayType === 'BARCODE');
    if(this.state.isUpdated) {
      isBarcodeList = this.state.isBarcodeList;
    }

    return (
      <div className="App fade">
        {this.renderTicketPageHeader(shopData, isBarcodeList, backLink)}
        <div className="App-container">
          <div className="group-items">
            <form>
              {this.renderGroups(ticketGroups, ticketGroupsCount, tickets, isBarcodeList)}
            </form>
          </div>
          {this.renderGroupsInfo(isBarcodeList, shopData)}
        </div>
        {
          isBarcodeList
          ? null
          : (
            <div className="App-navigator">
              <div className="check-navigator">
                <label>
                  <input 
                    type="checkbox"
                    onChange={this.AllTrueChange}
                    checked={allChecked}
                  />
                  <span className="icon-chk"></span>
                  <span className="txt-chk">전체 선택</span>
                </label>
              </div>
              <button type="button" 
                className="btn-navigator"
                onClick={this.openModal}
                dangerouslySetInnerHTML={ {__html: this.renderButtonText()} }
              />
            </div>
          )
        }
        <TicketModal />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/TicketPage.jsx